import { createEmitter } from "ts_utils";
import { ValidationUtils } from "ts_utils";
import { CreateUserDTO } from "../../data/dtos";
import { UserRole } from "../../data/UserRole";
import { FbAuth } from "../../services/firebase/FbAuth";
import { Services } from "../../services/Services";
import { UserManager } from "../UserManager";
import * as uih from "./UiHelper";

export class FinishAccountView {
	private _ui:HTMLDivElement;
	
	private _usernameInput:HTMLInputElement;
	
	private _finishAccountBtn:HTMLButtonElement;
	private _signoutLink:HTMLAnchorElement;
	private _messageDiv:HTMLDivElement;
	
	public get event() { return this._emitter.event; }
	private _emitter = createEmitter<FinishAccountViewEvent>();
	
	constructor(ui:HTMLDivElement){
		this._ui = ui;
		this._init();
	}
	
	private _init():void {
		uih.hide(this._ui);
		
		this._usernameInput = this._ui.querySelector("#fav-usernameInput");
		
		this._messageDiv = this._ui.querySelector(".shacc-message");
		uih.hide(this._messageDiv);
			
		this._finishAccountBtn = 
			this._ui.querySelector("#fav-finishAccountBtn");
		this._signoutLink = this._ui.querySelector("#fav-signoutLink");
	}
	
	public activate():void {
		uih.show(this._ui);
		this._usernameInput.value = "";
		uih.hide(this._messageDiv);
		UserManager.get().hideLoadingOverlay();
		this._addListeners();
	}
	
	public deactivate():void {
		uih.hide(this._ui);
		this._removeListeners();
	}
	
	private _onFinishAccountBtnClick = async (e:MouseEvent):Promise<void> => {
		uih.hide(this._messageDiv);
		let username:string = this._usernameInput.value.trim();
		if (ValidationUtils.isValidUsername(username)){
			this._removeListeners();
			UserManager.get().showLoadingOverlay();
			await this._createUserOnServer(username);
		}
		else {
			this._messageDiv.innerHTML = "Name must begin with a letter and " +
				"contain only letters and numbers.";
			uih.show(this._messageDiv);
		}
	}
	
	private _onSignoutLinkClick = (e:MouseEvent):void => {
		this._emitter.emit(FinishAccountViewEvent.signoutRequest);
	}
	
	private async _createUserOnServer(displayName:string):Promise<void> {
		let user = FbAuth.getCurrentUser();
		let dto = new CreateUserDTO();
		dto.email = user.email
		dto.fbUserId = user.uid
		dto.displayName = displayName
		dto.role = UserRole.USER;
		let rdto = await Services.createUser(dto);
		if (!rdto.success){
			this._displayFailMessage(rdto.message);
			this._addListeners();
			UserManager.get().hideLoadingOverlay();
			return null;
		}
		else {
			this._emitter.emit(FinishAccountViewEvent.accountFinished);
		}
	}
	
	private _displayFailMessage(message:string):void {
		if (message === "already exists"){
			this._messageDiv.innerHTML = "This account already exists. Try " +
				"signing out and signing back in.";
			uih.show(this._messageDiv);
		}
		else if (message === "username exists"){
			this._messageDiv.innerHTML = "This display name is already "
				"taken. Try a different name, or try adding numbers to your " +
				"name to find a unique name";
			uih.show(this._messageDiv);
		}
	}
	
	private _addListeners():void {
		this._removeListeners();
		this._finishAccountBtn.addEventListener("click",
			this._onFinishAccountBtnClick);
		this._signoutLink.addEventListener("click", this._onSignoutLinkClick);
	}
	
	private _removeListeners():void {
		this._finishAccountBtn.removeEventListener("click",
			this._onFinishAccountBtnClick);
		this._signoutLink.removeEventListener("click",
			this._onSignoutLinkClick);
	}
}

export enum FinishAccountViewEvent {
	accountFinished,
	signoutRequest
}